module.exports = __webpack_public_path__ + "static/media/welcome_3.e418fcac.webp";